import { render, staticRenderFns } from "./AddEditCategoryDialog.vue?vue&type=template&id=b3ccea0a&scoped=true&"
import script from "./AddEditCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCategoryDialog.vue?vue&type=style&index=0&id=b3ccea0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ccea0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ccea0a')) {
      api.createRecord('b3ccea0a', component.options)
    } else {
      api.reload('b3ccea0a', component.options)
    }
    module.hot.accept("./AddEditCategoryDialog.vue?vue&type=template&id=b3ccea0a&scoped=true&", function () {
      api.rerender('b3ccea0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign-categories/AddEditCategoryDialog.vue"
export default component.exports